import { createFileRoute } from '@tanstack/react-router';
import { CompraList } from '@/features/compra/page/list/CompraList';

export const Route = createFileRoute('/a/compra/compra')({
    component: CompraList,
});
